const gTag = (event_name, event_attributes = "") => {
  if (window.gtag) {
    if (event_attributes !== "") {
      window.gtag("event", event_name, event_attributes);
    }
  }
};

export default gTag;
